import styled from 'styled-components';

export const Container = styled.div``;

export const Box = styled.div`
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  border-radius: 8px;
  display: flex;
  padding: 6px 8px;
  flex-direction: column;
  margin-bottom: 38px;
`;

export const SearchBar = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SearchInput = styled.input`
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.surface.variant};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  outline: none;
  font-weight: 300;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  &::placeholder {
    font-style: italic;
    color: ${(props) => props.theme.atlas.semantic.color.type.disabled};
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.variant};
  }
  flex: 1;
`;

export const RowContainer = styled.div<{ selected?: boolean }>`
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 300px;
  overflow: overlay;
`;
